const getUniqueStringsInArray = (arr) => {
  const seen = new Set();
  return arr.filter((item) => {
    const lower = item.toLowerCase();
    if (seen.has(lower)) {
      return false;
    }
    seen.add(lower);
    return true;
  });
};

const isStringJSON = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}

export {
  getUniqueStringsInArray,
  isStringJSON
};